var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.modalComponent)?_c('div',[_c(_vm.modalComponent,_vm._b({tag:"component",on:{"close":_vm.hideModal}},'component',_vm.modalProps,false))],1):_vm._e(),(_vm.dialogComponent)?_c('div',[_c(_vm.dialogComponent,_vm._b({tag:"component",on:{"close":_vm.hideDialog}},'component',_vm.dialogProps,false))],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }